module.exports = __webpack_public_path__ + "media/components/assets/img/logo/ryanair-29a5f15e29c2d0f829420d9f7da99b71.svg";